

<template>
    <div class="selection" :style="style" @mousedown.left.stop="center($event)" 
        :class="{'invalid': !isValid, 'selecting': selecting, 'selected': selected, 'noAnimation': !animated}">
        <div class="label"> <slot /> </div>
        <div class="color" />
        <label class="width" v-if="region.width || region.height" :class="{warning: region.width < 40}"> {{region.width}} </label>
        <label class="height" v-if="region.width || region.height" :class="{warning: region.height < 40}"> {{region.height}} </label>
        <div class="hitbox top" @mousedown.left.stop="border($event, {top: true})"/>
        <div class="hitbox bottom" @mousedown.left.stop="border($event, {bottom: true})"/>
        <div class="hitbox left" @mousedown.left.stop="border($event, {left: true})"/>
        <div class="hitbox right" @mousedown.left.stop="border($event, {right: true})"/>
        <div class="hitbox topLeft" @mousedown.left.stop="border($event, {top: true, left: true})"/>
        <div class="hitbox topRight" @mousedown.left.stop="border($event, {top: true, right: true})"/>
        <div class="hitbox bottomLeft" @mousedown.left.stop="border($event, {bottom: true, left: true})"/>
        <div class="hitbox bottomRight" @mousedown.left.stop="border($event, {bottom: true, right: true})"/>
    </div>
</template>

<script>
export default{
    emits: ['border', 'center'],
    props: {
        color: {
            type: String,
            default: 'rgba(112,83,163)'
        },
        region: {
            top: 0,
            left: 0,
            width: 0,
            height: 0
        },
        invalid: {
            type: Boolean,
            default: false
        },
        selecting: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: true
        }
    },
    computed:{
        style(){
            return {
                top: `${/* this.region.originalTop,  */this.region.top}px`, 
                left: `${/* this.region.originalLeft,  */this.region.left}px`,
                width: `${this.region.width}px`,
                height: `${this.region.height}px`,
            }
        },
        isValid(){
            return this.region.isValid()
        }
    },
    methods: {
        center(event){
            this.$emit('center', event)
        },
        border(event, attribute){
            this.$emit('border', [event, attribute])
        }
    },
}
</script>

<style scoped>
.selection{
    position: absolute; border: 1px dotted white; 
    border-radius: 0;
    box-sizing: border-box;
    box-sizing: content-box;
    width: 50px; height: 50px;
    top: 100px;
    transition: width .2s ease-in-out, height .2s ease-in-out;

    cursor: move;
    --border-width: 2px;
    --hitbox-width: 10px;
    --offset: calc((var(--hitbox-width) - var(--border-width)) / 2);
    --negative-offset: calc(-1 * var(--offset));
}
.selection.noAnimation{
    transition: none;
}

.color{
    width: 100%;
    height: 100%;
    background: v-bind('color'); 
    opacity: 0.5;
    border-radius: 0;
}

.label{
    width: max-content; height: max-content; 
    background: v-bind('color'); 
    color: white; 
    border-radius: 0; padding: 5px; max-height: 30px; border: 1px dotted white; 
    white-space: nowrap; position: absolute; transform: translateY(-100%);
    left: -1px;
}

.selecting label, .selection:hover label{
    display: flex;
}
label{
    display: none;
    width: max-content;
    position: absolute; 
    pointer-events: none;
    color: #fff;
    font-weight: 600;
    padding: 1px 5px;
}
label.warning{
    color: #fe5454;
    border-color: #fe5454;
}
label.width{
    top: 100%;
    left: 50%;
    transform: translate(-50%, -100%) translateY(-4px);
}
label.height{
    top: 50%;
    left: 0;
    transform: translate(0%, -50%) translateX(0px);
}

.hitbox{
    position: absolute; border-radius: 0;
    min-width: var(--hitbox-width);
    min-height: var(--hitbox-width);
    /* opacity: 0.7; */
    opacity: 0;
    top: 0;
}
.hitbox.top{
    width: 100%; cursor: ns-resize; 
    transform: translateY(-100%) translateY(var(--offset)); 
    background: yellow; 
}
.hitbox.bottom{
    width: 100%; cursor: ns-resize;
    top: 100%; 
    background: yellow; 
    transform: translateY(calc(var(--negative-offset))); 
}
.hitbox.left{
    height: 100%; cursor: ew-resize;
    transform: translateX(-100%) translateX(var(--offset)); 
    background: yellow; 
}
.hitbox.right{
    height: 100%; cursor: ew-resize;
    left: 100%;
    background: yellow;
    transform: translateX(calc(var(--negative-offset))); 
}
.hitbox.topRight{
    background: red; 
    left: 100%; cursor: nesw-resize;
    transform: translateY(-100%) translate(calc((var(--negative-offset))), calc(var(--offset)));
}
.hitbox.topLeft{
    background: red;  
    cursor: nwse-resize;
    transform: translate(-100%,-100%) translate(calc((var(--offset))), calc(var(--offset)));
}
.hitbox.bottomLeft{
    background: red; 
    top: 100%; cursor: nesw-resize;
    transform: translateX(-100%) translate(calc((var(--offset))), calc(var(--negative-offset)));
}
.hitbox.bottomRight{
    background: red; 
    top: 100%; left: 100%; cursor: nwse-resize;
    transform: translate(calc((var(--negative-offset))), calc(var(--negative-offset)));
}

.selection.invalid .color{
    background: none;
    /* border-color: #fe5454; */
}
.selection.invalid .label{
    color: #fff;
    background: #fe5454;
}
</style>